// HorseCard.jsx
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { GoDotFill } from "react-icons/go";

const HorseCard = ({ horseMatches }) => {
  const [activeTab, setActiveTab] = useState("ALL");
  const navigate = useNavigate();

  const countryIcons = {
    GB: "/Flags/GB.svg",
    FRA: "/Flags/FRA.svg",
    FR: "/Flags/FRA.svg",
    USA: "/Flags/USA.svg",
    AU: "/Flags/AUS.svg",
    IRE: "/Flags/IRE.svg",
    IE: "/Flags/IRE.svg",
    RSA: "/Flags/RSA.svg",
    NZ: "/Flags/NZ.svg",
    IN: "/Flags/IN.svg",
    ZA: "/Flags/ZA.svg",
    HK: "/Flags/HK.svg",
    US: "/Flags/USA.svg",
  };
  // Unique country codes from data
  const availableTabs = horseMatches
    ? ["ALL", ...new Set(horseMatches.map((e) => e?.cname))]
    : [];

  const handleNavigate = (gmid, raceName) => {
    setTimeout(() => {
      navigate(
        `/horseGame?gmid=${gmid}&sportsName=horse&raceName=${raceName}&sportId=${10}`
      );
    }, 200);
  };

  return (
    <div className="w-full mx-auto border border-[#ddd] bg-white">
         {/* Country selection */}
          <div className="flex w-full border-b border-[#c8ced3] justify-between bg-[#e2e2e2] items-center">
            <div className="w-full overflow-x-auto whitespace-nowrap">
              <div className="flex w-max">
                {availableTabs.map((label, index) => (
                  <button
                    key={label}
                    onClick={() => setActiveTab(label)}
                    className={`font-bold text-[11px] flex flex-col items-center justify-center h-[45px] w-[70px] ${
                      activeTab === label
                        ? "bg-[white] text-black border-l border-[#c8ced3] border-r border-[#c8ced3]"
                        : "bg-[#e2e2e2] text-gray-600"
                    }`}
                  >
                    {countryIcons[label] ? (
                      <img src={countryIcons[label]} width={20} alt={label} />
                    ) : index === 0 ? (
                      "ALL"
                    ) : (
                      label
                    )}
                    <b>{countryIcons[label] && label}</b>
                  </button>
                ))}
              </div>
            </div>
          </div>

      {/* Filtered Data */}
          {horseMatches
            ?.filter((e) => activeTab === "ALL" || e?.cname === activeTab)
            .map((e, i) => {
              return (
                <div className="mb-4" key={i}>
                  <div className="p-1 pl-2 font-bold text-[13.5px] text-[white] bg-gradient-to-r from-[#172832] via-[#1e3a4c] to-[#2c4d63] ">
                    {e?.cname}
                  </div>

                  {e?.children?.map((e, i) => {
                    let firstMatch = e?.children?.[0]?.stime;
                    firstMatch = firstMatch;
                    const matchDate = firstMatch
                      ? new Date(firstMatch).toLocaleDateString("en-GB", {
                          day: "2-digit",
                          month: "short",
                        })
                      : "";
                    const allMatchClosed = e?.childs?.every(
                      (match) => match?.gOdds?.status === "CLOSED"
                    );
                    if (allMatchClosed) {
                      return null;
                    }
                    const trackNameAndDate = `${e?.ename} ${matchDate}`;
                    return (
                      <div className="border-b p-2" key={i}>
                        <div className="font-bold text-[14px] font-[sans-serif]">
                          {trackNameAndDate}
                        </div>
                        <div className="flex flex-wrap gap-2 mt-2">
                          {e?.children?.map((match, index) => {
                            const matchTime = new Date(match.stime);
                            matchTime.setMinutes(matchTime.getMinutes() - 20);
                            const currentTime = new Date();
                            currentTime.setMinutes(
                              currentTime.getMinutes() + 10
                            );
                            const currentlyAheadOfMatchTime =
                              matchTime <= currentTime;
                            const isActive =
                              currentlyAheadOfMatchTime &&
                              match?.gOdds?.status !== "CLOSED" &&
                              match?.gOdds?.status !== "SUSPENDED";
                            if (match?.gOdds?.status === "CLOSED") {
                              return null;
                            }
                            const correctMatchTime = new Date(match.stime);
                            const formattedTime =
                              correctMatchTime.toLocaleTimeString([], {
                                hour: "2-digit",
                                minute: "2-digit",
                                hour12: false,
                              });

                            const showFormattedTime =
                              correctMatchTime.toLocaleTimeString([], {
                                hour: "2-digit",
                                minute: "2-digit",
                                hour12: true,
                              });

                            const raceName =
                              trackNameAndDate + " " + formattedTime;
                            const now = new Date(); // Current time

                            const timeDifferenceInMinutes = Math.floor(
                              (correctMatchTime - now) / (1000 * 60)
                            );
                            return (
                              <button
                                // to={`/Market?marketId=${match?.eventId}`}
                                onClick={() =>
                                  handleNavigate(
                                    match?.gmid?.toString(),
                                    raceName,
                                    match.hOdds
                                  )
                                }
                                key={index}
                                className={`px-1.5 flex items-center py-1.5 rounded text-[13px] ${
                                  isActive
                                    ? "bg-[#0c667e] text-[white]"
                                    : "bg-[#E8E8E8]"
                                } border border-transparent hover:border-[0.5px] hover:border-[#27a6c3]`}
                              >
                                <span
                                  className={
                                    timeDifferenceInMinutes < 5
                                      ? "inplay2"
                                      : undefined
                                  }
                                >
                                  {showFormattedTime}{" "}
                                </span>
                                {
                                  <GoDotFill
                                    className={`ml-1 ${isActive && "inplay2"}`}
                                    color={
                                      match?.gOdds?.status === "SUSPENDED"
                                        ? "red"
                                        : "green"
                                    }
                                  />
                                }
                              </button>
                            );
                          })}
                        </div>
                      </div>
                    );
                  })}
                </div>
              );
            })}
    </div>
  );
};

export default HorseCard;
